import { ACL_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  Error,
  PutApiClientSpacesRequestParams
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onSuccess?: (value: PutApiClientSpacesRequestParams) => void
  onError?: (error: Error) => void
  children?: (value: PutApiClientSpacesRequestParams) => ReactElement
  apiAccessId: string
}

const GetApiClientSpacesRequest = ({
  apiAccessId,
  onSuccess,
  onError,
  children
}: Props) => {
  const requestParams = {
    principal_type: 'api_access',
    resource_type: 'space',
    action: 'full'
  } as PutApiClientSpacesRequestParams

  const url = `${ACL_SERVICE}/principals/${apiAccessId}/access`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default GetApiClientSpacesRequest
